import React from 'react';
import { observer } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import Button from 'ati-ui-react/components/Button';
import { useStores } from 'hooks/useStores';
import { addMetric } from 'utils/addMetrics';
import { ActionButton } from './EditButtonStyles';

/**
 * Кнопка, отправляющая на форму редактирования
 */
const EditButton = observer(
  ({
    className,
    advert,
    primary = false,
    size = 'small',
    children,
    hash = '',
    theme = '',
    setPage,
    before = '',
  }) => {
    const {
      advertsStore: { setCurrentEditAdvert },
    } = useStores();

    const history = useHistory();
    const editDescription = children || 'Редактировать';

    if (!advert) return null;

    const handleEditAd = (e) => {
      e.stopPropagation();
      history.push(`/cabinet/form${hash && `#${hash}`}`);
      setCurrentEditAdvert(advert);

      if (setPage === 'advert') {
        addMetric('paid-from-transport-page');
      }
    };

    return (
      <ActionButton className={className} onClick={handleEditAd}>
        <Button primary={primary} size={size !== 'reset' && size} theme={theme} before={before}>
          {!before && editDescription}
        </Button>
      </ActionButton>
    );
  },
);

export default EditButton;
